<template>
  <article v-html="pagePart" />
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchResultsDescription extends Vue {
  @Prop()
  pagePart: string
}

export default toNative(SearchResultsDescription)
</script>
<style scoped>
article {
  padding: 1.4em;
  border-bottom: 4px solid var(--colour-page-background);
}

article :deep(*) {
  text-align: left !important;
}

article :deep(img) {
  float: none !important;
  height: auto;
  margin: 1em -1.4em 0 !important;
  max-width: 100vw;
  width: 100vw;
}

article :deep(h1),
article :deep(h2),
article :deep(h3),
article :deep(h4),
article :deep(h5) {
  color: var(--colour-dark-blue);
  line-height: 1.3;
}

article :deep(h1) {
  text-align: left !important;
  font-size: 1.5em;
}

article :deep(h2),
article :deep(h3),
article :deep(h4) {
  margin: 1.25em 0 0.5em;
}

article :deep(h1 + h2) {
  margin-top: 0;
}

article :deep(li),
article :deep(p) {
  text-align: left !important;
  font-size: 16px;
  line-height: 1.5;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}

article :deep(li p) {
  font-size: inherit;
}

article :deep(em) {
  font-style: italic;
}

article :deep(ul ul) {
  padding-left: 1em;
}

article :deep(ul ul li) {
  list-style-type: circle;
}

article :deep(ul) {
  padding-left: 0;
  margin-bottom: 0.8em;
}

article :deep(li) {
  list-style: disc;
  margin-bottom: 0.5em;
  margin-left: 1em;
}

article :deep(a:not(.button)) {
  font-weight: bold;
  text-decoration: underline;
  transition: background-color 0.2s ease-out;
  color: var(--colour-dark-green);
}
article :deep(a:not(.button):active) {
  background-color: var(--colour-page-background);
  border-radius: 3px;
}

/* desktop & tablet */
article.desktop {
  padding-left: var(--page-width-padding);
}

article.desktop :deep(img) {
  margin: 1em 0 0 !important;
  max-width: none;
  width: auto;
}
</style>
